module.exports = __webpack_public_path__ + "static/CV-ca4c90585e1bd4e8b4ad900d851a1723.pdf";